import { memo } from 'react';
import { EmptyList } from './EmptyList';
import TEXT from './generated/TEXT/ErrorFallback';

TEXT.DEFINE({
  /** Error state description */
  emptyListCopy: 'Reload the page or check your internet connection.',
  /** Button label to reload the page */
  emptyListCta: 'Reload',
  /** Error state title */
  emptyListTitle: 'Something went wrong',
});

export const ErrorFallback = memo(function ErrorFallback() {
  return (
    <EmptyList
      onPress={() => window.location.reload()}
      shouldRender={true}
      text={TEXT}
    />
  );
});
